// 🟦 = blocked
// ⬜ = selected
// ⬛ = empty
// 🔳 = seat/click

export default {

  '⬛⬜🔳⬜⬛': [
    ({ seat }) => seat.isNotEdge(),
    ({ seat }) => ({
      deselect: seat.edge(),
      valid: false,
      stop: true,
    })
  ],

}
